const RATING_PRECISION = 10;

export const roundRatingValue = (value: number): number =>
  Math.round((value + Number.EPSILON) * RATING_PRECISION) / RATING_PRECISION;

export const formatRatingValue = (value: number): string =>
  roundRatingValue(value).toLocaleString('pt-BR', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  });
